import { Pagination, Table } from 'antd';
import React, { FC } from 'react';
import { TAnswerUsersInfoColumns, TAnswerUsersInfoPrepared } from 'shared/types/poll.types';
import style from './index.module.scss';

type TPollAnswerResultTableProps = {
  dataSource: TAnswerUsersInfoPrepared[];
  columns: TAnswerUsersInfoColumns;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
};

const PollAnswerResultTable: FC<TPollAnswerResultTableProps> = ({
  dataSource,
  columns,
  currentPage,
  currentSize,
  setCurrentPage,
  setCurrentSize,
  total,
}) => {
  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };
  return (
    <>
      <Table
        scroll={{ x: true }}
        dataSource={dataSource}
        columns={columns}
        rowClassName="row"
        pagination={false}
        bordered
      />
      <div className={style.paginationWrap}>
        <Pagination
          defaultCurrent={1}
          showSizeChanger
          current={currentPage}
          total={total}
          pageSize={currentSize}
          onChange={(page, pageSize) => handlePagination(page, pageSize)}
        />
      </div>
    </>
  );
};

export default PollAnswerResultTable;
